import { Modal } from 'antd-mobile';
import { appMethod as app } from '@utils/app';
import { getCurrentPageQueryParams, convertLineStyleData } from '@utils/tools';
import { TopNav } from '@common/top-nav/TopNav';
import OfficialPage from '../OfficialPage'

import './NumberOfStampsOrderDetail.less';

export default class NumberOfStampsOrderDetail extends OfficialPage {
  state = {
    orderData: {},
    orderInfo: {},
    hiddenmodalput: true,
    untimes: '', // 次数券的次数
    numberOfStampsUrl: '',
    addLabelText: '',
    status_name: {},
    goodsAdditionalInfo: {},
    hasAdditionalInfo: false,
    customFields: [],
    orderId: '',
    isFromTemplateMsg: false,
    originalPrice: '',
    useBalance: '',
    freightAdress: {},
    express_fee: '',
    discount_cut_price: '',
    isFromBack: false,
    showWriteOffCodeBox: false,
    showEventDialog: false,
    eventType: '',
    detailShow: true,
    cerificationShow: false,
    verifyShow: false,
    verifyData: {
      success: false,
      qrcodeUrl: ''
    }
  }
  verifiTimeInterval = ''

  constructor(props) {
    super(props);
    document.title = '订单详情';
  }

  componentWillMount(options = getCurrentPageQueryParams()) {
    this.setData({
      orderId: options.detail,
      isFromTemplateMsg: options.from === 'template_msg' ? true : false,
      franchiseeId: options.franchisee || ''
    })
    this.dataInitial()
  }

  componentDidMount() {
    if (this.data.isFromBack) {
      if (!!this.data.orderInfo.order_id) {
        this.getOrderDetail(this.data.orderInfo.order_id)
      }
    } else {
      this.setData({
        isFromBack: true
      })
    }
  }

  dataInitial = () => {
    this.getOrderDetail(this.data.orderId)
    this.setData({
      appName: app.globalData.appTitle,
      appLogo: app.globalData.appLogo
    })
  }
  getVerificationInfo = () => {
    this.setData({
      detailShow: false,
      cerificationShow: true
    })
  }
  getOrderDetail = orderId => {
    var that = this
    app.getOrderDetail({
      data: {
        order_id: orderId,
        sub_shop_app_id: this.data.franchiseeId
      },
      success: function(res) {
        var data = res.data[0],
          form_data = data.form_data,
          hasAdditionalInfo = false,
          additional_info_goods = [],
          additional_goodsid_arr = [],
          address_id = ''
        if (form_data.additional_info) {
          for (var i = 0; i < form_data.goods_info.length; i++) {
            var deliveryId = form_data.goods_info[i].delivery_id,
              goodsId = form_data.goods_info[i].goods_id
            if (
              deliveryId &&
              deliveryId != '0' &&
              additional_goodsid_arr.indexOf(goodsId) == -1
            ) {
              additional_info_goods.push(form_data.goods_info[i])
              additional_goodsid_arr.push(goodsId)
              hasAdditionalInfo = true
            }
          }
        }
        let remark = form_data.remark
        let status_name
        form_data.remark = remark ? remark.replace(/\n|\\n/g, '\n') : remark
        switch (form_data.status) {
          case '0':
            status_name = '未付款'
            break
          case '1':
            status_name = '已付款'
            break
          case '7':
            status_name = '已关闭'
            break
        }
        that.setData({
          orderData: data,
          orderInfo: form_data,
          hasAdditionalInfo: hasAdditionalInfo,
          discount_cut_price: form_data.discount_cut_price,
          useBalance: form_data['use_balance'],
          express_fee: res.data[0]['express_fee'],
          status_name: status_name
        })
        app.setPreviewGoodsInfo(additional_info_goods)
        app.setGoodsAdditionalInfo(form_data.additional_info || {})
      }
    })
  }
  goToHomepage = () => {
    var router = app.getHomepageRouter()
    app.turnToPage('/pages/' + router + '/' + router, true)
  }
  copyOrderId = () => {
    let _this = this
    app.setClipboardData({
      data: _this.data.orderId,
      success: function(res) {
        app.showToast({
          title: '复制成功',
          icon: 'success'
        })
      }
    })
  }
  addLabelInput = e => {
    this.setData({ addLabelText: e.target.value })
  }
  confirm = () => {
    if (+this.data.orderInfo.un_verify_times < +this.data.addLabelText) {
      app.showModal({ content: '核销次数超过剩余次数' })
      this.setData({ hiddenmodalput: true, addLabelText: '' })
      return
    }
    let url = this.data.numberOfStampsUrl + '&Number=' + this.data.addLabelText
    this.setData({ hiddenmodalput: true, addLabelText: '' })
    app.turnToPage(url, false)
  }
  cancel = () => {
    this.setData({ hiddenmodalput: true, addLabelText: '' })
  }
  getWriteOffCodeBox = () => {
    let couponId = this.data.orderInfo.user_coupon_id
    let franisee = this.data.franchiseeId
      ? this.data.franchiseeId
      : app.globalData.appId
    let url =
      '/exchangeCoupon/pages/numberOfStampsUsed/numberOfStampsUsed?detail=' +
      couponId +
      '&franchisee=' +
      franisee
    this.setData({ numberOfStampsUrl: url, hiddenmodalput: false })
  }
  hideCouponVerify = () => {
    this.setData({
      detailShow: true,
      verifyShow: false,
      cerificationShow: false
    })
    clearInterval(this.timeInterval)
    this.socketOpen && Taro.closeSocket()
  }
  timeInterval = ''
  socketOpen = false
  connectSocket = () => {
    var that = this
    Taro.connectSocket({
      url: 'wss://ceshi.zhichiwangluo.com', //线下test
      header: {
        'content-type': 'application/json'
      },
      method: 'GET'
    })
    Taro.onSocketOpen(function(res) {
      that.socketOpen = true
      let data = {
        action: 'mark_client',
        user_token: app.globalData.userInfo.user_token,
        scenario_name: 'app_coupon_verify',
        session_key: app.globalData.sessionKey
      }
      Taro.sendSocketMessage({
        data: JSON.stringify(data)
      })
      that.timeInterval = setInterval(function() {
        let data = {
          action: 'heartbeat',
          user_token: app.globalData.userInfo.user_token,
          scenario_name: 'app_coupon_verify',
          session_key: app.globalData.sessionKey
        }
        Taro.sendSocketMessage({
          data: JSON.stringify(data)
        })
      }, 30000)
    })
    Taro.onSocketMessage(function(res) {
      let data = JSON.parse(res.data)
      if (data.action == 'push_to_client') {
        let msg = JSON.parse(data.msg)
        if (msg.type == 'app_coupon_verify' && msg.status == 0) {
          that.setData({
            'verifyData.success': true
          })
          clearInterval(that.timeInterval)
          Taro.closeSocket()
        }
      }
    })
    Taro.onSocketClose(function(res) {
      that.socketOpen = false
      clearInterval(that.timeInterval)
      console.log('WebSocket 已关闭！')
    })
    Taro.onSocketError(function(res) {
      that.socketOpen = false
      console.log('WebSocket连接打开错误，请检查！')
    })
  }

  component() {
    var that = this
    clearInterval(that.timeInterval)
    that.socketOpen && Taro.closeSocket()
  }

  privateStopNoop(e) {
    e.stopPropagation()
  }

  render() {
    const {
      showGetUserInfo,
      detailShow,
      isFromTemplateMsg,
      status_name,
      orderInfo,
      appLogo,
      hiddenmodalput,
      addLabelText,
      labelFocus,
      cerificationShow
    } = this.state
    return (
      <div className="official-page number-of-stamps-order-detail">
        <TopNav title="订单详情"/>
        <React.Fragment>
          <div className={'order-contain ' + (detailShow ? 'show' : '')}>
            {isFromTemplateMsg && (
              <div
                className="orderDetail-goto-homepage"
                onClick={this.goToHomepage}
              >
                返回首页
              </div>
            )}
            <div className="seller-shipped">
              <div>{'订单状态：' + status_name}</div>
            </div>
            <React.Fragment>
              <div className="app-box">
                <div>
                  <span className="app-name">下单时间</span>
                  <div className="contact-service pull-right">
                    <span>{orderInfo.add_time}</span>
                  </div>
                </div>
              </div>
              <React.Fragment>
                <div className="goods-detail-box">
                  <img src={appLogo} />
                  <div>
                    {orderInfo.goods_info && orderInfo.goods_info.goods_name && (
                      <div
                        className="goods-rules"
                        style={convertLineStyleData('color: #333;font-size:26rpx')}
                      >
                        {orderInfo.goods_info.goods_name}
                      </div>
                    )}
                    <div className="goods-rules">
                      {'使用时间' + (orderInfo.goods_info && orderInfo.goods_info.expire)}
                    </div>
                    <div className="goods-price">
                      {orderInfo.goods_info && orderInfo.goods_info.price != 0 &&
                        orderInfo.goods_info.price != '0.00' && (
                          <span className="color333">
                            {'¥' + orderInfo.goods_info.price}
                          </span>
                        )}
                      {orderInfo.goods_info && orderInfo.goods_info.price != 0 &&
                        orderInfo.goods_info.price != '0.00' &&
                        orderInfo.goods_info.integral && (
                          <span className="color333">+</span>
                        )}
                      {orderInfo.goods_info && orderInfo.goods_info.integral && (
                        <span className="color333">
                          {orderInfo.goods_info.integral + '积分'}
                        </span>
                      )}
                      <span className="pull-right">x 1</span>
                    </div>
                  </div>
                </div>
              </React.Fragment>
            </React.Fragment>
            <div className="actual-payment">
              <div>
                <span>实际付款</span>
                <span className="pull-right colorff7">
                  {'¥' + orderInfo.total_price}
                </span>
              </div>
            </div>
            {orderInfo.status != 0 && orderInfo.coupon_type == 6 && (
              <div className="order-used">
                <div
                  className="order-used-title"
                  onClick={this.getVerificationInfo}
                >
                  <span>核销情况</span>
                  <div className="ico-moon icon-rightarrow"></div>
                </div>
                <div className="order-used-line order-used-bottom">
                  <div>已核销</div>
                  <div className="colorff7">
                    {orderInfo.verified_times + '次'}
                  </div>
                </div>
                <div className="order-used-line">
                  <div>未核销</div>
                  <div className="colorff7">
                    {orderInfo.un_verify_times + '次'}
                  </div>
                </div>
              </div>
            )}
            <div className="order-number">
              <div>
                <span>订单编号</span>
                <span>{orderInfo.order_id}</span>
                <span className="pull-right" onClick={this.copyOrderId}>
                  复制
                </span>
              </div>
            </div>
            {orderInfo.coupon_type == 6 &&
              orderInfo.can_verify == 1 &&
              orderInfo.status != 0 &&
              orderInfo.un_verify_times != 0 && (
                <div className="order-bottom">
                  <span className="btn" onClick={this.getWriteOffCodeBox}>
                    核销码
                  </span>
                </div>
              )}
          </div>
          <Modal
            visible={!hiddenmodalput}
            transparent
            title="请输入本次核销次数"
            maskClosable={true}
            platform="'ios'"
            footer={[{
              text: '取消',
              onPress: this.cancel,
            }, {
              text: '确认',
              onPress: this.confirm,
            }]}
          >
            <input
              type="number"
              placeholder="请输入本次核销次数"
              maxLength="6"
              onChange={this.addLabelInput}
              value={addLabelText}
              style={{
                background:'#F5F5F5',
                height: '.76rem',
                borderRadius:'.10rem',
                padding: '.10rem .10rem',
                boxSizing: 'border-box',
                border: 0
              }}
            />
          </Modal>
          <div
            className={
              'coupon-cerification-info ' + (cerificationShow ? 'show' : '')
            }
          >
            {orderInfo.verify_log && orderInfo.verify_log.length > 0 && (
              <div className="ceification-info-title">
                <span className="ceification-info-left">核销次数</span>
                <span>核销时间</span>
              </div>
            )}
            {orderInfo.verify_log && orderInfo.verify_log.length > 0 && (
              <div style={convertLineStyleData('min-height:300rpx;background: #fff;')}>
                {orderInfo.verify_log.map((item, index) => {
                  return (
                    <div className="ceification-info-line" key="key">
                      <span className="ceification-info-left">
                        {item.consume_times}
                      </span>
                      <span>{item.add_time}</span>
                    </div>
                  )
                })}
              </div>
            )}
            {orderInfo.verify_log && orderInfo.verify_log.length == 0 && (
              <div className="coupon-cerification-nodata">- 暂无数据 -</div>
            )}
            <div style={convertLineStyleData('text-align:center')}>
              <div
                className="ceification-info-back"
                onClick={this.hideCouponVerify}
              >
                返回
              </div>
            </div>
          </div>
        </React.Fragment>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/official-page/number-of-stamps-order-detail/NumberOfStampsOrderDetail.jsx